import React from "react";
export default React.createContext({
    requestId: "",
    userAgent: {},
    availableLocales: [],
    features: {},
    auth: { enabled: true, clientId: "", redirectUri: "", isAuthenticatedOnWeb: false },
    supplierFeatures: [],
    isFlightsDomain: true,
    shouldNotTrack: false,
    apiPrefix: "",
    myIp: "",
    searchHistory: [],
    searchHistoryPrefill: undefined,
    voidExcludedCountries: [],
    rebookExcludedCountries: [],
    isPaymentCollectionPage: false,
    mapsApiKeys: {
        GOOGLE: "",
        BAIDU: ""
    }
});
